export default __webpack_public_path__ + "static/media/date of birth.2125ee3e.png";